<template>
  <b-modal id="comment-form-modal" v-model="isOpen" centered hide-header hide-footer @close="isOpen = false">
    <div class="comment-form">
      <div class="comment-form__title">
        <div class="title">{{ title }}</div>

        <div v-if="parentCommentAuthor" class="author">
          <a v-if="parentCommentAuthor.link" :href="parentCommentAuthor.link" class="author__name" target="_blank">{{
            parentCommentAuthor.name
          }}</a>
          <span v-else class="author__name">{{ parentCommentAuthor.name }}</span>
        </div>
      </div>

      <form @submit.prevent="submit">
        <c-textarea v-model="text" floating-label="Комментарий" />

        <file-loader
          ref="loader"
          v-model="files"
          class="comment-form__loader"
          format="images,pdf,docs"
          actions="loadFiles,preview"
          :links="fileLinks"
          @changeLinks="fileLinks = $event"
        ></file-loader>
      </form>

      <div class="comment-form__actions">
        <c-button class="comment-form__reset" label="Отменить" @click="close" />
        <c-button class="comment-form__submit" color="primary" label="Отправить" @click="submit" />
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";

import CTextarea from "@/components/controls/textarea";
import FileLoader from "@/components/file-loader";
import CButton from "@/components/controls2/Button";

export default {
  name: "m-link",
  components: {
    CButton,
    CTextarea,
    FileLoader,
  },
  props: ["pending", "parent"],
  data() {
    return {
      comment: null,

      isOpen: false,
      isSubmitted: false,

      text: "",
      files: [],
      fileLinks: [],
    };
  },
  computed: {
    ...mapState(["user"]),

    oldFiles() {
      return this.fileLinks || [];
    },

    isTextValid() {
      return this.text.trim().length;
    },

    isValid() {
      return this.isTextValid;
    },
    parentCommentAuthor() {
      if (!this.parent) return null;
      const { worker, user } = this.parent;

      if (worker) {
        const { name, id } = worker;
        return {
          name,
          link: `/?r=redesing#/personal-employee/${id}/summary`,
        };
      }

      return {
        name: user.name,
      };
    },
    title() {
      if (this.comment) {
        return this.parent ? "Редактировать ответ на комментарий" : "Редактировать комментарий";
      }
      return this.parent ? "Ответить на комментарий" : "Написать комментарий";
    },
  },
  watch: {
    isOpen(v) {
      if (!v) {
        this.comment = null;
        this.$emit("closed");
        this.reset();
      }
    },
  },
  methods: {
    open(comment) {
      if (comment) {
        this.comment = comment;
        this.setInitialData(this.comment);
      }
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    setInitialData(data) {
      this.text = data.message;
      this.fileLinks = data.files.map((file) => ({
        id: file.id,
        url: file.name,
      }));
    },

    getParams() {
      const params = {
        message: this.text,
        files: this.files,
        oldFiles: this.oldFiles.map((file) => file.id),
      };

      return params;
    },

    submit() {
      this.isSubmitted = true;

      if (!this.isValid) return;

      this.$emit("submitted", this.getParams());
    },

    reset() {
      this.isSubmitted = false;
      this.text = "";
      this.$refs.loader.clear();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.comment-form {
  &__loader {
    margin-top: 24px;
  }

  &__title {
    .title {
      font-size: 15px;
      font-weight: 500;
    }
    .author {
      font-size: 13px;
    }

    margin-bottom: 24px;
  }

  &__actions {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
  }

  @include onlyMobile {
    &__actions {
      margin: 30px -20px -20px;
    }

    &__reset,
    &__submit {
      flex-grow: 1;
      border-radius: 0;
    }
  }
}
</style>

<style lang="scss">
#comment-form-modal {
  .modal-content {
    height: auto;
  }
}
</style>
